//Trivia acciones
export enum TriviaContextTypes {
    SET_TRIVIA = 'Trivia - Set info trivia',
    SET_ACTIVE_QUESTION = 'Trivia - Set Active Question',
    SELECT_OPTION_QUESTION = 'Trivia - Select Option Question',
    SET_MISSING_RESPONSE = 'Trivia - Missing Response Change',
    SET_RESPONSE = 'Trivia - Response Trivia',
    SET_LOAD_TRIVIA = 'Trivia - Load Trivia',
    SET_OPEN_TRIVIA = 'Trivia - Open Trivia',
    CLOSE_AND_CLEAR = 'Trivia - Close And Clear Trivia',
    SET_TRIVIA_ID = 'Trivia - Set trivia ID',
    RETRY_TRIVIA = 'Trivia - Retry Trivia'
}

// Book acciones context
export enum BookContextTypes {
    ACTION_TYPE_SET_INFO = 'Book - Set Info',
}

// Referencias acciones
export enum ReferencesContextTypes {
    ACTION_TYPE_SET_NEW_REFERENCE = 'References - Set new reference',
}